import { FC, ReactNode } from "react";
import { useFormContext } from "react-hook-form";

type Props = {
  label: ReactNode;
  name: string;
  className?: string;
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const InputContainer: FC<Props> = ({
  children,
  label,
  name,
  className,
}) => {
  const {
    formState: { errors, touchedFields },
  } = useFormContext();
  return (
    <label
      className={classNames(
        "w-full text-sm font-medium text-gray-700",
        className
      )}
      htmlFor={name}>
      <span className='inline-flex'>
        {label}
        {errors[name] ? (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-3 w-3 my-auto ml-1 text-red-default'
            viewBox='0 0 20 20'
            fill='currentColor'>
            <path
              fillRule='evenodd'
              d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
              clipRule='evenodd'
            />
          </svg>
        ) : touchedFields[name] ? (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-3 w-3 my-auto ml-1 text-green-default'
            viewBox='0 0 20 20'
            fill='currentColor'>
            <path
              fillRule='evenodd'
              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
              clipRule='evenodd'
            />
          </svg>
        ) : null}
      </span>
      {children}
      {errors[name] ? <p>{errors[name].message}</p> : null}
    </label>
  );
};
